export default __webpack_public_path__ + "static/media/prev.dd42696f.svg";